import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const PostaUpravit = lazy(() =>
  import('@/modules/posta/PostaUpravit').then((m) => ({ default: m.PostaUpravit })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/posta/$id/upravit',
  component: () => (
    <Suspense fallback={null}>
      <PostaUpravit />
    </Suspense>
  ),
});
